module.exports = __webpack_public_path__ + "img/4-1.7711cc81.png";